import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boldText',
})
export class BoldTextPipe implements PipeTransform {
  transform(value: string): unknown {
    const splittedValue = value.split('**');

    let res = '';
    splittedValue.forEach((elt, index) => {
      if (index % 2 !== 0) {
        res += `<b>${elt}</b>`;
      } else {
        res += elt;
      }
    });

    return res;
  }
}
